import { Injectable, ViewContainerRef, ComponentRef, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    public viewContainerRef!: ViewContainerRef;
    public modalComponentRef!: ComponentRef<any>;
    public modalNotifier$!: Subject<any>;

    // Register the ViewContainerRef where modals will be dynamically added
    registerViewContainerRef(vcr: ViewContainerRef): void {
        this.viewContainerRef = vcr;
    }

    // Open the modal with data
    open(component: any, data: any): Observable<any> {
        this.viewContainerRef.clear();
        this.modalNotifier$ = new Subject();
        this.modalComponentRef = this.viewContainerRef.createComponent(component);
        // Pass data to the modal component instance via @Input
        Object.assign(this.modalComponentRef.instance, { modalData: data });
        this.modalComponentRef.changeDetectorRef.detectChanges();
        // Subscribe to the modal component's close event via @Output
        if (this.modalComponentRef.instance.closeEvent instanceof EventEmitter) {
            this.modalComponentRef.instance.closeEvent.subscribe((result: any) => {
                this.close(result);
            });
        }
        return this.modalNotifier$.asObservable();
    }

    // Close the modal and emit result
    close(result?: any): void {
        if (this.modalComponentRef) {
            this.modalNotifier$.next(result);
            this.modalNotifier$.complete();
            this.modalComponentRef.destroy();
        }
    }
}
